import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const FontContext = createContext();

const useFont = () => useContext(FontContext);

const FontProvider = ({ children }) => {
  const [font, setFont] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFont();
  }, []);

  const loadFont = async () => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_STRAPI_API_URL + "/api/font")
      .then(({ data }) => {
        setFont(data.data.attributes);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading font configuration:", error);
        setLoading(false);
      });
  };

  return (
    <FontContext.Provider value={{ font, loading }}>
      {children}
    </FontContext.Provider>
  );
};

export { FontProvider, useFont };
